exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[type=checkbox]{transform:scale(1.5)}@media(max-width:767px){.no-margin{margin:0;padding:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77314d5e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/dashboard/profile/Profile.vue
// module id = 79
// module chunks = 0 1 2